export enum TipoSolicitudRefacturacion {
  Reemplazo,
  Anulacion,
  SinSolicitud,
  Manual
}
